import { render } from "./icon.vue?vue&type=template&id=9313a1a6"
import script from "./icon.vue?vue&type=script&lang=js"
export * from "./icon.vue?vue&type=script&lang=js"
script.render = render

export default script